import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/(embeds)/embed.scss");
;
import(/* webpackMode: "eager", webpackExports: ["EmbeddedAnalytics"] */ "/app/apps/PublicUI/app/(embeds)/EmbeddedAnalytics/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedResizer"] */ "/app/apps/PublicUI/app/(embeds)/EmbedResizer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedResumability"] */ "/app/apps/PublicUI/app/(embeds)/EmbedResumability/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedScroll"] */ "/app/apps/PublicUI/app/(embeds)/EmbedScroll/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedAppContext"] */ "/app/apps/PublicUI/contexts/AppContext/index.tsx");
